import React from "react";
import foto from "../../images/Calendario Cigno 20232024.jpg"
import FrecciaIndietro from "../../commons/FrecciaIndietro";
import Space from "../../commons/Space";
import regolamento from "../../images/Nuoto/Regolamento_piscina.png"
import TitoloSezioni from "../../commons/TitoloSezioni";
import ScrollToTopOnMount from "../../components/ScrollToTopOnMount";
import TitoloColore from "../../commons/TitoloColore";


function RegolamentoPiscina () {
    return(
        <div className="text-center">
            <ScrollToTopOnMount />
            <TitoloColore title={"Regolamento piscina"} backgroundColor={"#003F83"} />
            <FrecciaIndietro indirizzo={"/piscina"} />
            <div className="container-foto-news m-auto" style={{display: "flex", flexDirection: "column"}}>
                <img src={regolamento} style={{width: "100%", boxShadow: "15px 15px 20px rgba(0, 0, 0, 0.5)"}}></img>
            </div>
            <Space />

        </div>
    )
}
export default RegolamentoPiscina